<template>
  <popup
    :opened="dataToShow"
    @close="changeToShow(false)"
  >
    <message-header :message-header="messageHeader" />

    <div class="sticky top-0 z-10">
      <!-- Save button -->
      <save-button
        :saving="saving"
        @save="saveBeneficiaryRights"
        class="right-15 top-15"
      />
    </div>

    <!-- BEGIN Content modal beneficiary rights -->
    <div class="my-5 lg:m-15 2xl:m-20">
      <h3 class="mb-10">
        Modifier les droits d'accès de <br>
        {{ beneficiaryToEdit.firstname }}
        <span class="uppercase">{{ beneficiaryToEdit.lastname }}</span>
      </h3>
      <div class="text-left text-pink-600 text-lg mb-10">
        DROITS ET RESTRICTIONS
      </div>

      <!-- BEGIN list of permissions per group -->
      <!-- First group is for neopass form permissions -->
      <div class="odd:bg-indigo-100 odd:bg-opacity-50">
        <!-- BEGIN Informations on accordion -->
        <div
          id="accordion_neopass_form"
          class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              groupPermissionsDisplay == constants.PERMISSION_NEOPASS_FORM_PAGE,
          }"
          @click="
            displayGroupPermissions(constants.PERMISSION_NEOPASS_FORM_PAGE)
          "
        >
          <div class="col-span-1 text-pink-600 place-self-center">
            <icon
              class="inline-block transform transition-transform ease-in-out duration-300"
              :class="{
                'rotate-90':
                  groupPermissionsDisplay ==
                  constants.PERMISSION_NEOPASS_FORM_PAGE,
              }"
              name="chevron-right"
            />
          </div>
          <div class="col-span-11 w-full text-base">
            Formulaire carnet de parcours
          </div>
        </div>
        <!-- END Informations on accordion -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-if="
              groupPermissionsDisplay == constants.PERMISSION_NEOPASS_FORM_PAGE
            "
            class="w-full bg-white grid grid-cols-2 justify-start pt-10"
          >
            <div class="col-span-full sm:col-span-1">
              <div
                v-if="
                  listNeopassModulesPages.filter(
                    (m) =>
                      permissions.includes(m.name + '_read') &&
                      m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
                  ).length > 0
                "
              >
                <checkbox-indigo
                  name="Lecture"
                  libelle="LECTURE"
                  :value="
                    (
                      (
                        ((beneficiaryToEdit || {}).rights || {}).neopassForm ||
                        {}
                      ).read || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        (
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {}
                      ).all = newValue;
                      checkallNeopassForm('read', 'all', newValue);

                      if (!newValue) {
                        (
                          (
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).edit || {}
                        ).all = newValue;
                        checkallNeopassForm('edit', 'all', newValue);
                      }
                    }
                  "
                  color-libelle="text-indigo-600"
                  size-libelle="text-base"
                />
              </div>
              <div
                v-for="(mod, numMod) in listNeopassModulesPages.filter(
                  (m) =>
                    permissions.includes(m.name + '_read') &&
                    m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
                )"
                :key="numMod"
                class="m-3"
              >
                <div>
                  <checkbox-indigo
                    :name="mod.name"
                    :libelle="mod.display_name"
                    :value="
                      (
                        ((
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {})[mod.name] || {}
                      ).all
                    "
                    @input="
                      (newValue) => {
                        (
                          ((
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).read || {})[mod.name] || {}
                        ).all = newValue;
                        checkallNeopassForm('read', mod.name, newValue);
                        decheckallNeopassForm('read', mod.name, newValue);

                        if (!newValue) {
                          (
                            ((
                              ((beneficiaryToEdit || {}).rights || {})
                                .neopassForm || {}
                            ).edit || {})[mod.name] || {}
                          ).all = newValue;
                          checkallNeopassForm('edit', mod.name, newValue);
                          decheckallNeopassForm('edit', mod.name, newValue);
                        }
                      }
                    "
                    class="mb-1.5"
                    size-libelle="text-base"
                  />
                </div>

                <div
                  v-for="(page, numPage) in mod.pages.filter((p) =>
                    permissions.includes(p.name + '_read')
                  )"
                  :key="numPage"
                >
                  <checkbox-indigo
                    :name="page.name"
                    :libelle="page.display_name"
                    :value="
                      (((
                        ((beneficiaryToEdit || {}).rights || {}).neopassForm ||
                        {}
                      ).read || {})[mod.name] || {})[page.name]
                    "
                    @input="
                      (newValue) => {
                        (((
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).read || {})[mod.name] || {})[page.name] = newValue;
                        decheckallNeopassForm('read', mod.name, newValue);

                        if (!newValue) {
                          (((
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).edit || {})[mod.name] || {})[page.name] = newValue;
                          decheckallNeopassForm('edit', mod.name, newValue);
                        }
                      }
                    "
                    color-libelle="text-gray-600"
                    size-libelle="text-base"
                    weight-libelle="font-light"
                  />
                </div>
              </div>
            </div>
            <div class="col-span-full sm:col-span-1">
              <div
                v-if="
                  listNeopassModulesPages.filter(
                    (m) =>
                      permissions.includes(m.name + '_edit') &&
                      m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
                  ).length > 0
                "
              >
                <checkbox-indigo
                  name="Ecriture"
                  libelle="ECRITURE"
                  :value="
                    (
                      (
                        ((beneficiaryToEdit || {}).rights || {}).neopassForm ||
                        {}
                      ).edit || {}
                    ).all
                  "
                  @input="
                    (newValue) => {
                      (
                        (
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {}
                      ).all = newValue;
                      checkallNeopassForm('edit', 'all', newValue);
                      if (newValue) {
                        (
                          (
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).read || {}
                        ).all = newValue;
                        checkallNeopassForm('read', 'all', newValue);
                      }
                    }
                  "
                  color-libelle="w-1/2 text-indigo-600"
                  size-libelle="text-base"
                />
              </div>
              <div
                v-for="(mod, numMod) in listNeopassModulesPages.filter(
                  (m) =>
                    permissions.includes(m.name + '_edit') &&
                    m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
                )"
                :key="numMod"
                class="m-3"
              >
                <div>
                  <checkbox-indigo
                    :name="mod.name"
                    :libelle="mod.display_name"
                    :value="
                      (
                        ((
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {})[mod.name] || {}
                      ).all
                    "
                    @input="
                      (newValue) => {
                        (
                          ((
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).edit || {})[mod.name] || {}
                        ).all = newValue;
                        checkallNeopassForm('edit', mod.name, newValue);
                        decheckallNeopassForm('edit', mod.name, newValue);

                        if (newValue) {
                          (
                            ((
                              ((beneficiaryToEdit || {}).rights || {})
                                .neopassForm || {}
                            ).read || {})[mod.name] || {}
                          ).all = newValue;
                          checkallNeopassForm('read', mod.name, newValue);
                        }
                      }
                    "
                    class="mb-1.5"
                    size-libelle="text-base"
                  />
                </div>
                <div
                  v-for="(page, numPage) in mod.pages.filter((p) =>
                    permissions.includes(p.name + '_edit')
                  )"
                  :key="numPage"
                >
                  <checkbox-indigo
                    :name="page.name"
                    :libelle="page.display_name"
                    :value="
                      (((
                        ((beneficiaryToEdit || {}).rights || {}).neopassForm ||
                        {}
                      ).edit || {})[mod.name] || {})[page.name]
                    "
                    @input="
                      (newValue) => {
                        (((
                          ((beneficiaryToEdit || {}).rights || {})
                            .neopassForm || {}
                        ).edit || {})[mod.name] || {})[page.name] = newValue;
                        decheckallNeopassForm('edit', mod.name, newValue);
                        if (newValue) {
                          (((
                            ((beneficiaryToEdit || {}).rights || {})
                              .neopassForm || {}
                          ).read || {})[mod.name] || {})[page.name] = newValue;
                        }
                      }
                    "
                    color-libelle="text-gray-600"
                    size-libelle="text-base"
                    weight-libelle="font-light"
                  />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Then, there are other modules -->
      <div
        v-for="(group, num_grp) in listPermissions.filter(
          (p) => p.type == 'page' && !notDisplayedModules.includes(p.module)
        )"
        :key="num_grp"
        class="odd:bg-indigo-100 odd:bg-opacity-50"
      >
        <!-- BEGIN Informations on accordion -->
        <div
          :id="'accordion_' + group.module"
          class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              groupPermissionsDisplay == group.module,
          }"
          @click="displayGroupPermissions(group.module)"
        >
          <div class="col-span-1 text-pink-600 place-self-center">
            <icon
              class="inline-block transform transition-transform ease-in-out duration-300"
              :class="{ 'rotate-90': groupPermissionsDisplay == group.module }"
              name="chevron-right"
            />
          </div>
          <div
            class="col-span-11 text-base place-self-center justify-self-start"
          >
            {{ group.display_name }}
          </div>
        </div>
        <!-- END Informations on accordion -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <!-- BEGIN Form content -->
          <div
            v-if="groupPermissionsDisplay == group.module"
            class="bg-white grid grid-cols-2 gap-x-4 gap-y-5 py-5"
          >
            <div class="col-span-full">
              <checkbox-indigo
                name="tout"
                :libelle="getLibelle(group)"
                color-libelle="indigo-600"
                :value="
                  (((beneficiaryToEdit || {}).rights || {})[group.module] || {})
                    .all
                "
                @input="
                  (newValue) => {
                    (
                      ((beneficiaryToEdit || {}).rights || {})[group.module] ||
                      {}
                    ).all = newValue;
                    checkallModule(group.module);
                  }
                "
                size-libelle="text-base"
              />
            </div>
            <div
              v-for="(func, num_func) in filterPermissions(group)"
              :key="num_func"
              class="col-span-full sm:col-span-1"
            >
              <checkbox-indigo
                :name="func.name"
                :libelle="func.display_name"
                color-libelle="indigo-600"
                :value="
                  (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                    {})[func.name]
                "
                @input="
                  (newValue) => {
                    (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                      {})[func.name] = newValue;
                    decheckallModule(group.module, func.name);
                  }
                "
                size-libelle="text-base"
              />
            </div>
            <div
              v-if="group.module == constants.MODULE_FICHE_DE_POSTE"
              class="col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
            >
              <div class="col-span-full">
                <checkbox-indigo
                  name="tout_personnal_library"
                  libelle="Tout dans bibliothèque personnelle"
                  color-libelle="indigo-600"
                  :value="
                    (((beneficiaryToEdit || {}).rights || {})[group.module] || {})
                      .allPersonnal
                  "
                  @input="
                    (newValue) => {
                      (
                        ((beneficiaryToEdit || {}).rights || {})[group.module] ||
                        {}
                      ).allPersonnal = newValue;
                      checkAllFicheDePostePersonnalLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="col-span-1 text-base mb-3"
                />
              </div>
              <div
                v-for="(func, num_func) in listPermissions.filter(
                  (p) =>
                    p.module == group.module &&
                    p.module == constants.MODULE_FICHE_DE_POSTE &&
                    p.type == 'function' &&
                    p.name.includes('job_description_personnal') &&
                    p.name !=
                    constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE
                )"
                :key="num_func"
                class="col-span-full sm:col-span-1"
              >
                <checkbox-indigo
                  :name="func.name"
                  :libelle="func.display_name"
                  color-libelle="indigo-600"
                  :value="
                    (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                      {})[func.name]
                  "
                  @input="
                    (newValue) => {
                      (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                        {})[func.name] = newValue;
                      decheckAllFicheDePostePersonnalLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="text-base"
                />
              </div>
            </div>
            <div
              v-if="group.module == constants.MODULE_FICHE_DE_POSTE"
              class="col-span-full grid grid-cols-2 gap-x-4 gap-y-5 self-start"
            >
              <checkbox-indigo
                name="tout_shared_library"
                libelle="Tout dans bibliothèque commune"
                color-libelle="indigo-600"
                :value="
                  (((beneficiaryToEdit || {}).rights || {})[group.module] || {})
                    .allShared
                "
                @input="
                  (newValue) => {
                    (
                      ((beneficiaryToEdit || {}).rights || {})[group.module] ||
                      {}
                    ).allShared = newValue;
                    checkAllFicheDePosteSharedLibrary(newValue);
                    decheckallModule(group.module, newValue);
                  }
                "
                size-libelle="col-span-1 text-base mb-3"
              />
              <div
                v-for="(func, num_func) in listPermissions.filter(
                  (p) =>
                    p.module == group.module &&
                    p.module == constants.MODULE_FICHE_DE_POSTE &&
                    p.type == 'function' &&
                    p.name.includes('job_description_shared') &&
                    p.name != constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE
                )"
                :key="num_func"
                class="col-span-full sm:col-span-1"
              >
                <checkbox-indigo
                  :name="func.name"
                  :libelle="func.display_name"
                  color-libelle="indigo-600"
                  :value="
                    (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                      {})[func.name]
                  "
                  @input="
                    (newValue) => {
                      (((beneficiaryToEdit || {}).rights || {})[group.module] ||
                        {})[func.name] = newValue;
                      decheckAllFicheDePosteSharedLibrary(newValue);
                      decheckallModule(group.module, newValue);
                    }
                  "
                  size-libelle="text-base"
                />
              </div>
            </div>
          </div>
          <!-- END Form content -->
        </transition>
      </div>
      <!-- END list of permissions per group -->
    </div>
    <!-- END Content modal beneficiary rights -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import MessageHeader from './../../../components/MessageHeader';
import Icon from './../../../components/Icon';
import CheckboxIndigo from './../../../components/Inputs/CheckboxIndigo';

import SaveButton from './../../../components/SaveButton.vue';

import Constants from './../../../constants';

export default {
  name: 'EditBenficiaryRightsPopup',

  props: {
    dataToShow: Boolean,
  },

  data() {
    return {
      groupPermissionsDisplay: '',
      notDisplayedModules: [
        'dashboard',
        'menu',
        Constants.MODULE_NEOPASS_LISTE,
        Constants.MODULE_NEOPASS_FORM,
        Constants.PERMISSION_NEOPASS_FORM_PAGE,
        Constants.MODULE_CARTOGRAPHIES_COLLECTIVES,
      ],
      constants: Constants,
    };
  },

  components: {
    Popup,
    MessageHeader,
    Icon,
    CheckboxIndigo,
    SaveButton,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      beneficiaryToEdit: 'beneficiaries/beneficiaryToEdit',
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      listPermissions: 'permissions/listPermissions',
      errors: 'permissions/errors',
      permissions: 'auth/permissions',
    }),
  },

  methods: {
    ...mapActions({
      saveBeneficiaryRights: 'beneficiaries/saveBeneficiaryRights',
    }),

    ...mapMutations({
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    getLibelle(group) {

      const simpleModules = [
        Constants.MODULE_RECHERCHE_COMPETENCES, Constants.MODULE_DEPOT_DOCUMENTS, Constants.PERMISSION_AIDE_PAGE, Constants.MODULE_COMPETENCES
      ];

      if (simpleModules.includes(group.module)) {
        return 'Accès au module';
      }

      return 'Tout';
    },

    filterPermissions(group) {
      const inCurrentModule = (p) => p.module === group.module;
      const isFunction = (p) => p.type === 'function';
      const isNotFicheDePoste = (p) => p.module !== Constants.MODULE_FICHE_DE_POSTE;
      const isNotReferentielFormation = (p) => p.module !== Constants.MODULE_REFERENTIEL_FORMATION;
      const isNotDepotDocuments = (p) => p.module !== Constants.MODULE_DEPOT_DOCUMENTS;
      const isNotHelpPage = (p) => p.module !== Constants.PERMISSION_AIDE_PAGE;

      return this.listPermissions
        .filter(inCurrentModule)
        .filter(isNotFicheDePoste)
        .filter(isNotReferentielFormation)
        .filter(isNotDepotDocuments)
        .filter(isNotHelpPage)
        .filter(isFunction);
    },

    changeToShow(val) {
      this.groupPermissionsDisplay = '';
      this.$emit('showChange', val);
      this.SET_ERRORS(null);
      this.SET_SAVING(false);
    },

    checkallNeopassForm(readOrEdit, moduleName, state) {
      if (moduleName == 'all') {
        for (let mod in this.beneficiaryToEdit.rights.neopassForm[readOrEdit]) {
          if (mod != 'all') {
            for (var page in this.beneficiaryToEdit.rights.neopassForm[
              readOrEdit
            ][mod]) {
              this.beneficiaryToEdit.rights.neopassForm[readOrEdit][mod][page] =
                state;
            }
          }
        }
      } else {
        for (var page in this.beneficiaryToEdit.rights.neopassForm[readOrEdit][
          moduleName
        ]) {
          if (page != 'all') {
            this.beneficiaryToEdit.rights.neopassForm[readOrEdit][moduleName][
              page
            ] = state;
          }
        }
      }
    },

    decheckallNeopassForm(readOrEdit, moduleName, state) {
      if (this.beneficiaryToEdit.rights.neopassForm[readOrEdit].all) {
        this.beneficiaryToEdit.rights.neopassForm[readOrEdit].all = state;
      }

      if (
        this.beneficiaryToEdit.rights.neopassForm[readOrEdit][moduleName].all
      ) {
        this.beneficiaryToEdit.rights.neopassForm[readOrEdit][moduleName].all =
          state;
      }
    },

    checkallModule(moduleName) {
      let state = this.beneficiaryToEdit.rights[moduleName].all;
      for (const [key, func] of Object.entries(
        this.beneficiaryToEdit.rights[moduleName]
      )) {
        this.beneficiaryToEdit.rights[moduleName][key] = state;
      }
    },

    decheckallModule(moduleName, functionName) {
      let state = this.beneficiaryToEdit.rights[moduleName][functionName];
      if (this.beneficiaryToEdit.rights[moduleName].all) {
        this.beneficiaryToEdit.rights[moduleName].all = state;
      }
    },

    checkAllFicheDePostePersonnalLibrary(state) {
      for (const [key, func] of Object.entries(
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
      ).filter((p) => p[0].includes('job_description_personnal'))) {
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE][
          key
        ] = state;
      }
    },

    decheckAllFicheDePostePersonnalLibrary(state) {
      if (
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
          .allPersonnal
      ) {
        this.beneficiaryToEdit.rights[
          Constants.PERMISSION_FICHE_DE_POSTE_PAGE
        ].allPersonnal = state;
      }
    },

    checkAllFicheDePosteSharedLibrary(state) {
      for (const [key, func] of Object.entries(
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
      ).filter((p) => p[0].includes('job_description_shared'))) {
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE][
          key
        ] = state;
      }
    },

    decheckAllFicheDePosteSharedLibrary(state) {
      if (
        this.beneficiaryToEdit.rights[Constants.PERMISSION_FICHE_DE_POSTE_PAGE]
          .allShared
      ) {
        this.beneficiaryToEdit.rights[
          Constants.PERMISSION_FICHE_DE_POSTE_PAGE
        ].allShared = state;
      }
    },

    displayGroupPermissions(groupName) {
      if (this.groupPermissionsDisplay == groupName) {
        this.groupPermissionsDisplay = '';
      } else {
        this.groupPermissionsDisplay = groupName;
        let pos = document.getElementById('accordion_' + groupName);
        setTimeout(() => {
          pos.scrollIntoView({ block: 'start' });
        }, 300);
      }
    },
  },
};
</script>
